import React, { useState } from 'react';
import { Service } from '../../models/Entities/Service';
import {
  PrimaryButton,
  SearchBox,
  IIconProps
} from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import ServiceListComponent from '../../components/Services/ServiceList/ServiceList.Component';
import ServiceFormComponent from '../../components/Services/ServiceForm';
import { PageHeader } from '../../commons/component/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';

export const ServicesListPage = () => {
  const AddIcon: IIconProps = { iconName: 'CirclePlus' };
  const [selectedService, setSelectedService] = useState<Service | undefined>();
  const [searchCriteria, setSearchCriteria] = useState<string>();

  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [t] = useTranslation();

  // events
  const handleEditEvent = (service: Service) => {
    setSelectedService(service);
    openPanel();
  };

  const handleClosePanel = () => {
    setSelectedService(undefined);
    dismissPanel();
  };

  const handleAddClick = () => {
    setSelectedService(undefined);
    openPanel();
  };

  const onSearch = (
    event?: React.ChangeEvent<HTMLInputElement> | undefined,
    newValue?: string | undefined
  ) => {
    setSearchCriteria(newValue);
  };

  return (
    <>
      <PageHeader title={t('servicesListPage.title')} />
      <div className="Section">
        <div className="listHeader">
          <PrimaryButton
            secondaryText={t('servicesListPage.button.addService')}
            onClick={handleAddClick}
            text={t('servicesListPage.button.addService')}
            iconProps={AddIcon}
            className="actionButton"
          />
          <SearchBox
            placeholder={t('servicesListPage.searchPlaceholder')}
            onChange={onSearch}
            underlined={false}
          />
        </div>
        <ServiceListComponent
          onEdit={handleEditEvent}
          searchCriteria={searchCriteria}
        />
        <ServiceFormComponent
          isOpen={isOpen}
          openPanel={openPanel}
          dismissPanel={handleClosePanel}
          Service={selectedService}
        />
      </div>
    </>
  );
};
